import { createNotificationsModule } from '@izimi/modules';
import { notificationsApi } from 'core/di';

export const notificationsModule = createNotificationsModule({
  notificationsApi,
});
